<template>
  <b-container>
    <b-row>
      <b-col cols="8">
        <div class="filters">
          <label for="city-search">Cidade:</label>
          <v-select id="city-search" :options="cities" v-model="citySelected">
            <template #no-options> Nenhuma cidade encontrada. </template>
          </v-select>
        </div>

        <b-table striped hover sticky-header head-variant="dark" :items="items" :fields="fields">
          <template #cell(action)="data">
            <b-button v-show="!!data.item.check === true" variant="danger" @click="delItem(data)">Remover</b-button>
            <b-button v-show="!!data.item.check === false" variant="primary" @click="addItem(data)">Adicionar</b-button>
          </template>
        </b-table>

        <div class="total-count">
          Total: <b>{{ totalChecked }}</b> contato<span v-show="totalChecked > 1">s</span> adicionado<span v-show="totalChecked > 1">s</span>.
        </div>

        <div class="add-or-remove-all">
          <b-button variant="primary" @click="addAll">Adicionar todos</b-button>
          <b-button variant="danger" @click="delAll">Remover todos</b-button>
        </div>

        <div class="submit-form-container">
          <b-button class="submit-button" v-show="totalChecked > 0 && mensagem.length" @click="submitForm">
            Enviar Mensagem
          </b-button>
        </div>
      </b-col>

      <b-col cols="4">
        <label for="input-message">Mensagem:</label>

        <div class="mt-2" v-for="index in elementos" :key="index">
          <b-form-textarea
            :id="`input-message_${index}`"
            size="lg"
            placeholder="Digite a mensagem aqui."
            rows="5"
            v-model="mensagem[index - 1]"
            @keyup="keyup"
          ></b-form-textarea>

          <b-form-file
            class="c-file"
            v-model="file"
            accept=".jpg, .jfif, .jpeg, .png, .gif, .pdf"
            :state="Boolean(file)"
            placeholder="Escolha a Imagem ou PDF..."
            drop-placeholder="Arraste para aqui..."
            browse-text="Procurar"
          ></b-form-file>
          <div class="mt-1">{{ file ? 'Arquivo selecionado: ' + file.name : '' }}</div>
        </div>

        <b-row class="float-right">
          <b-col>
            <b-button @click="decreaseMsg"> - </b-button>
            <b-button @click="increaseMsg"> + </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
const socket = require('../../modules/realtime/service/service');

export default {
  name: 'ViewMessage',

  props: {
    wallets: { type: Array, default: () => [] },
    cities:  { type: Array, default: () => [] }
  },

  data() {
    return {
      at_wallets: this.wallets,
      citySelected: null,
      elementos: 1,
      items: [],
      fields: [
        { key: 'action', label: 'Ação' },
        { key: 'name',   label: 'Nome',     sortable: true },
        { key: 'phone',  label: 'Telefone', sortable: true },
        { key: 'city',   label: 'Cidade',   sortable: true },
      ],
      mensagem: [],    
      srcImage: null,   
      file: null
    };
  },

  methods: {
    decreaseMsg() { if (this.elementos > 1) this.elementos--; },
    increaseMsg() { if (this.elementos < 4) this.elementos++; },

    keyup(e) {
      const idx = Number(e.target.id.split('_')[1]) - 1;
      this.$emit('updateText', idx, e.target.value);
    },

    addItem(data) { data.item.check = true; },
    delItem(data) { data.item.check = false; },
    addAll()      { this.items.forEach(i => i.check = true); },
    delAll()      { this.items.forEach(i => i.check = false); },

    submitForm() {
      const selecionados = this.at_wallets.filter(i => i.check);
      if (selecionados.length === 0) {
        Swal.fire({ type: 'error', title: 'Erro!', text: "Informe os contatos da campanha!" });
        return;
      }

      const temTexto = this.mensagem.some(t => (t || '').trim().length > 0);
      const temMidia = !!this.srcImage;

      if (!temTexto && !temMidia) {
        Swal.fire({ type: 'error', title: 'Erro!', text: "Digite a mensagem da campanha!" });
        return;
      }

      const id = Date.now();
      const obj = {
        mensagem: this.mensagem, 
        media: {
          type:     this.file ? this.file.type : null,
          filename: this.file ? this.file.name : null,
          file:     this.srcImage || null
        },
        telefones: selecionados.map(({ name, phone }) => ({ name, phone, id }))
      };

      try {
        if (obj.media.file && obj.media.file.match(/,(.+)$/)) {
          obj.media.file = obj.media.file.match(/,(.+)$/)[1];
        }
      } catch {
        delete obj.media;
      }

      // dispara a campanha
      socket.connection.emit('startCampaing', obj, (data) => {
        console.log('Callback:', data);
      });

      Swal.fire(
        'Campanha Iniciada',
        'Os clientes selecionados vão receber a mensagem nos próximos minutos',
        'success'
      ).then(() => location.reload());
    }
  },

  computed: {
    totalChecked() {
      return this.wallets.reduce((acc, el) => acc + (el.check ? 1 : 0), 0);
    }
  },

  watch: {
    citySelected(value) {
      this.items = value
        ? this.at_wallets.filter(i => i.city === value)
        : this.at_wallets;
    },

    file() {
      if (
        this.file &&
        ['application/pdf', 'image/jpeg', 'image/png', 'image/gif', 'image/jpg', 'image/jfif'].includes(this.file.type)
      ) {
        const reader = new FileReader();
        reader.readAsDataURL(this.file);
        reader.onloadend = () => {
          this.srcImage = reader.result;
          this.$emit('addImage', this.srcImage);
        };
      } else {
        if (this.file) {
          Swal.fire({
            type: 'error',
            text: 'O arquivo selecionado não é válido. Escolha uma Imagem (jpeg, jpg, png e gif) ou PDF.'
          });
        }
        this.file = null;
        this.srcImage = null;
      }
    }
  },

  mounted() {
    this.items = this.at_wallets;
  }
};
</script>

<style scoped>
.total-count { margin-bottom: 12px; }
.filters     { margin-bottom: 12px; }
.c-file      { margin-top: 12px; }
.submit-form-container { margin-top: 12px; }
.submit-button { margin-top: 12px; color: #fff; background: #25d366; width: 180px; border: none; }
</style>
